import styled from 'styled-components';

export const Card = styled.div`
    margin-bottom: 27px;
    > div {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 4px #00000029;
        padding: 19px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
`;

export const CardTitle = styled.h1`
    font-size: 14px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    letter-spacing: 1px;
    font-weight: bold;
`;

export const CardCounter = styled.div`
    > em {
        display: block;
        text-align: center;
        font-style: normal;
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-size: 30px;
    }
`;

export const CardStatus = styled.div`
    > em {
        color: #2B2932;
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-size: 14px;
        text-align: center;
        display: block;
        font-style: normal;
        overflow-wrap: break-word;
        // height: 2em;
        // line-height: 2em;
    }
`;
